module.exports = __webpack_public_path__ + "static/media/A10.d0ab83ba.png";